export default __webpack_public_path__ + "static/media/push-to-card.fbce5b5a.svg";